;(function () {
    function EnlargableImage(enlargable) {
        /**
         * local object availability
         * @type {EnlargableImage}
         * @private
         */
        var _this = this

        /**
         * The original, in the document existing image and the
         * On click of this image the overlay opens
         *
         * @type {HTMLElement}
         * @private
         */
        _this.originating = enlargable.querySelector('figure')

        /**
         * The image overly html element
         * @type {HTMLElement}
         * @private
         */
        _this.overlay = enlargable.querySelector('.enlargable-image-overlay')

        /**
         * The close btn html element to close the image overlay
         * @type {HTMLElement}
         * @private
         */
        _this.closeBtn = enlargable.querySelector('.enlargable-image-overlay-close')

        /**
         * The image inside the overlay
         * @type {HTMLElement}
         * @private
         */
        _this.enlargedImage

        /**
         * The uncompressed original image src
         * @type {String}
         * @private
         */
        _this.originalSrc = enlargable.dataset.originalSrc

        /**
         * If the enlargable image is zoomed in
         * @type {boolean}
         * @private
         */
        _this.isZoomed = false

        /**
         * If the enlargable image is currently being dragged
         * @type {boolean}
         * @private
         */
        _this.isDragging = false

        /**
         * The start position if a new drag starts. Is needed to calculate the delta movement
         * @type {int}
         * @private
         */
        _this.dragStartX = 0
        _this.dragStartY = 0

        /**
         * The dragged distance: This is applied the image
         * @type {int}
         * @private
         */
        _this.totalDraggedX = 0
        _this.totalDraggedY = 0

        /**
         * The last position of the last drag
         * @type {int}
         * @private
         */
        _this.lastDraggedX = 0
        _this.lastDraggedY = 0

        /**
         * Create the Image DOM inside the already rendered enlargable-image-overlay
         * (only if it doesn't already exist)
         *
         * @method createEnlargedImageDOM
         * @returns {undefined}
         */
        _this.createEnlargedImageDOM = function () {
            //check if image has already been created in the overlay
            if (!_this.overlay.querySelector('img')) {
                var img = document.createElement('img')
                var src = _this.originalSrc

                img.setAttribute('src', src)
                _this.enlargedImage = img
                _this.overlay.appendChild(img)
                _this.setEnlargedImageEventListeners()
            }
        }

        /**
         * Set all of the required EventListeners for the previously created enlargable-image
         *
         * @method setEnlargedImageEventListeners
         * @returns {undefined}
         */
        _this.setEnlargedImageEventListeners = function () {
            _this.enlargedImage.addEventListener('click', _this.zoomIn)
            _this.enlargedImage.addEventListener('mousedown', _this.startDrag)
            _this.enlargedImage.addEventListener('mousemove', _this.drag)
            _this.enlargedImage.addEventListener('mouseup', _this.stopDragging)

            _this.enlargedImage.addEventListener('touchstart', _this.zoomIn)
            _this.enlargedImage.addEventListener('touchstart', _this.startDrag)
            _this.enlargedImage.addEventListener('touchmove', _this.drag)
            _this.enlargedImage.addEventListener('touchend', _this.stopDragging)
        }

        /**
         * Start the drag on mousedown/touchstart, saves the start position to calculate the delta movement
         *
         * @method startDrag
         * @param {Event} event
         * @returns {undefined}
         */
        _this.startDrag = function (event) {
            if (!_this.isZoomed) return

            event.preventDefault()

            _this.isDragging = true

            _this.dragStartX = event.type === 'mousedown' ? event.clientX : event.touches[0].clientX;
            _this.dragStartY = event.type === 'mousedown' ? event.clientY : event.touches[0].clientY;

            // console.log("drag start: ", _this.dragStartX, " / ", _this.dragStartY)
        }

        /**
         * Stop the drag on mouseup/touchend, check if it was a click or drag
         *
         * @method stopDragOrZoomOut
         * @param {Event} event
         * @returns {undefined}
         */
        _this.stopDragging = function (event) {
            if (!_this.isZoomed) return

            _this.isDragging = false;

            _this.lastDraggedX = _this.totalDraggedX
            _this.lastDraggedY = _this.totalDraggedY
        }

        /**
         * Recalculate the new image position and apply it constantly to the image while being pressed down
         *
         * @method drag
         * @param {Event} event
         * @returns {undefined}
         */
        _this.drag = function (event) {
            if (_this.isDragging && _this.isZoomed) {
                event.preventDefault();

                const currentX = event.type === 'mousemove' ? event.clientX : event.touches[0].clientX;
                const currentY = event.type === 'mousemove' ? event.clientY : event.touches[0].clientY;

                _this.totalDraggedX = currentX - _this.dragStartX + _this.lastDraggedX;
                _this.totalDraggedY = currentY - _this.dragStartY + _this.lastDraggedY;

                _this.updateEnlargedImagePosition();

                // console.log("drag: ", _this.totalDraggedX, " / ", _this.totalDraggedY);
            }
        }

        /**
         * Reapply the new object position of the image.
         * Take note of the "font-family: object-fit: xxx": this makes use of a polyfill
         * For more informations regarding the polyfill checkout: https://github.com/fregante/object-fit-images
         *
         * @method updateEnlargedImagePosition
         * @returns {undefined}
         */
        _this.updateEnlargedImagePosition = function () {
            _this.enlargedImage.style.objectPosition =
                'calc(50% + ' + _this.totalDraggedX + 'px) calc(50% + ' + _this.totalDraggedY + 'px)'
            _this.enlargedImage.style.fontFamily =
                'object-fit: contain; object-position: calc(50% + ' +
                _this.totalDraggedX +
                'px) calc(50% + ' +
                _this.totalDraggedY +
                'px)'
        }

        /**
         * Zoom out of the enlarged image (don't close the overlay, but zoom out of the previously zoomed-in image)
         *
         * @method zoomOut
         * @returns {undefined}
         */
        _this.zoomOut = function () {
            _this.enlargedImage.style.cursor = 'zoom-in'
            _this.enlargedImage.style.objectFit = 'contain'
            _this.enlargedImage.style.objectPosition = '50% 50%'
            _this.enlargedImage.style.fontFamily = 'object-fit: contain; object-position: 50% 50%'
            _this.isZoomed = false
        }

        /**
         * Zoom into the enlarged image (don't open the overlay, but zoom into the previously opened overly-image)
         *
         * @method zoomIn
         * @returns {undefined}
         */
        _this.zoomIn = function () {
            if (_this.isZoomed) return
            _this.enlargedImage.style.cursor = 'move'
            _this.enlargedImage.style.objectFit = 'none'
            _this.enlargedImage.style.fontFamily = 'object-fit: none'
            _this.updateEnlargedImagePosition()
            _this.isZoomed = true
        }

        /**
         * Show the enlarged-image-overlay
         *
         * @method showOverlay
         * @returns {undefined}
         */
        _this.showOverlay = function () {
            _this.overlay.classList.add('show')
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
        }

        /**
         * Hide the enlarged-image-overlay
         *
         * @method hideOverlay
         * @returns {undefined}
         */
        _this.hideOverlay = function () {
            _this.overlay.classList.remove('show')
            document.body.style.overflow = "";
            document.body.style.position = "";
        }

        /**
         * Set EventListener to close the Overlay if ESC is being pressed
         */
        document.addEventListener('keyup', function (event) {
            if (event.key === 'Escape') {
                _this.hideOverlay()
            }
        })

        /**
         * Set EventListener to close the Overlay if the close btn is being pressed (in the top right corner)
         */
        _this.closeBtn.addEventListener('click', function () {
            _this.zoomOut()
            _this.hideOverlay()
        })

        /**
         * Preload the image inside of the overlay on hover of the original image
         */
        _this.originating.addEventListener('mouseover', function () {
            _this.createEnlargedImageDOM()
        })

        /**
         * Open the image-overlay on click of the original image
         */
        _this.originating.addEventListener('click', function () {
            _this.showOverlay()
        })
    }

    /**
     * global availability
     */
    window.Energy = window.Energy || {}
    window.Energy.EnlargableImage = EnlargableImage
})()

/**
 * Initialize all of the enlargable-images if dom has loaded
 */
if (document.readyState !== 'loading') {
    initEnlargableImages()
} else {
    document.addEventListener('DOMContentLoaded', function () {
        initEnlargableImages()
    })
}

/**
 * Global function to initialize all of the enlargable-images on a page
 * Gets called on document content loaded
 *
 * @method initEnlargableImages
 * @returns {undefined}
 */
function initEnlargableImages() {
    var inNeosBackend = document.querySelector('body').classList.contains('neos-backend')
    if (!inNeosBackend) {
        var enlargables = document.querySelectorAll('.image-enlargable')
        for (var i = 0; i < enlargables.length; i++) {
            new window.Energy.EnlargableImage(enlargables[i])
        }
    }
}
